import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { LogisticsActionKeys, UpdateShipmentContainer } from '..';
import { httpService } from '../../..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { ApiUrls } from '../../ApiUrls';
import { executeApiRequest } from '../../asyncUtils';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { logisticsActionCreators } from '../logisticsActionCreators';
import { IShipmentContainer } from '../logisticsInterfaces';

function* updateShipmentContainerSaga(action: UpdateShipmentContainer) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(executeUpdate, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(logisticsActionCreators.setContainer(response.value.value));
    }
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateShipmentContainer() {
  yield takeEvery(LogisticsActionKeys.UPDATE_SHIPMENT_CONTAINER, updateShipmentContainerSaga);
}

export async function executeUpdate(
  container: IShipmentContainer
): Promise<IApiExecuteRespone<IEntityWithMessages<IShipmentContainer>>> {
  return executeApiRequest(() =>
    httpService.post(`${ApiUrls.shipment()}/Containers/${container.shipmentContainerId}`, container)
  );
}
